import {Typography} from "antd"
import {TextProps} from "antd/lib/typography/Text"
import {TitleProps} from "antd/lib/typography/Title"
import React, {FC} from "react"
import {JShortcodeParser} from "../JShortcodeParser"
import './JHTML.scss'

export interface JHTMLTextProps extends TextProps {
    html: string
    style?: React.CSSProperties
    styleSpan?: React.CSSProperties
    additionalClasses?: string
}

const JHTMLText: FC<JHTMLTextProps> = ({html, ...props}) => {
    return (
        <Typography.Text {...props} style={props?.style} className={`jcms-html-text ${props?.additionalClasses}`}>
            <span style={props?.styleSpan} className={props?.additionalClasses}>
                <JShortcodeParser html={html}/>
            </span>
        </Typography.Text>
    )
}

export interface JHTMLTitleProps extends TitleProps {
    html: string
    style?: React.CSSProperties
    styleSpan?: React.CSSProperties
    additionalClasses?: string
}

const JHTMLTitle: FC<JHTMLTitleProps> = ({html, ...props}) => {
    return (
        <Typography.Title {...props} style={props?.style} className={`jcms-html-title ${props?.additionalClasses}`}>
            <span style={props?.styleSpan} className={props?.additionalClasses}>
                <JShortcodeParser html={html}/>
            </span>
        </Typography.Title>
    )
}

const JHTMLSectionTitle: FC<JHTMLTitleProps> = ({html, ...props}) => {
    return (
        <Typography.Title {...props} style={props?.style} className={`jcms-html-title jcms-html-section-title ${props?.additionalClasses}`}
                          level={props.level || 2}>
            <span style={props?.styleSpan} className={props?.additionalClasses}>
                <JShortcodeParser html={html}/>
            </span>
        </Typography.Title>
    )
}

const JHTMLPageTitle: FC<JHTMLTitleProps> = ({html, ...props}) => {
    return (
        <Typography.Title {...props} className={`jcms-html-title jcms-html-page-title ${props?.additionalClasses}`} level={props.level || 1}>
            <span style={props?.styleSpan} className={props?.additionalClasses}>
                <JShortcodeParser html={html}/>
            </span>
        </Typography.Title>
    )
}

export interface JHTMLSubTitleProps extends TextProps {
    html: string,
    style?: React.CSSProperties
    styleSpan?: React.CSSProperties
    additionalClasses?: string
}

const JHTMLSubTitle: FC<JHTMLSubTitleProps> = ({html, ...props}) => {
    return (
        <Typography.Text {...props} style={props?.style} className={`jcms-html-subtitle ${props?.additionalClasses}`}>
            <span style={props?.styleSpan} className={props?.additionalClasses}>
                <JShortcodeParser html={html}/>
            </span>
        </Typography.Text>
    )
}

export const JHTML = {
    Title: JHTMLTitle,
    SectionTitle: JHTMLSectionTitle,
    PageTitle: JHTMLPageTitle,
    SubTitle: JHTMLSubTitle,
    Text: JHTMLText
}
